import { addDays,differenceInYears,format,formatDistanceToNow,formatDuration,intervalToDuration,isToday,isWithinInterval,parse,startOfDay } from 'date-fns';
import { primaryColor } from "./constants";

export const debounce = (cb, delay = 1000) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            cb(...args);
        }, delay);
    }
};

// ISO 3166-1 alpha-2 code -> flag via Unicode regional indicators ("AE" -> UAE
// flag). Platforms without flag glyphs (Windows) show the letter pair instead.
export const isoToFlag = (iso) =>
  typeof iso === "string" && iso.length === 2
    ? iso.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)))
    : "";

export const toTitleCase = (str) => {
    return str.replace(
      /\w\S*/g,
      text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  }


  export const customStyleSelect = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? primaryColor : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: primaryColor,
      },
      zIndex:1000
    }),
  };


  let dateFormat = 'MMM dd, yyyy'
  let birthdayFormat = 'MMM dd'
  let dateWithTimeFormat = 'MMM dd, yyyy hh:mm a'

  export const formatDateHandler = (date)=>{
    if(date){
      return format(new Date(date), dateFormat);

    }
    return ""
  }
  export const formatBirthdayHandler = (date)=>{
    if(date){
      return format(new Date(date), birthdayFormat);

    }
    return ""
  }

  export const formatDateHandler2 = (date)=>{
    let dateFormat = 'dd-MM-yyyy'

    if(date){
      return format(new Date(date), dateFormat);

    }
    return ""
  }

  export const formatDateWithTimeHandler = (date)=>{

    if(date){
      return format(new Date(date), dateWithTimeFormat);

    }
    return ""
  }

  export const formatDateHandler3 = (date)=>{
    let dateFormat = 'MMMM yyyy'

    if(date){
      return format(new Date(date), dateFormat);

    }
    return ""
  }





  export const dateLeftHandler = (date) => {
    if(date){
      let now = new Date()
      const duration = intervalToDuration({ start: now, end: new Date(date) });
      return formatDuration(duration, {
        format: ["years","months",'days' ],
        zero: false, // Exclude zero values
      });
    }
    return ""
 
  }


  export const filterHandler = (filters) => {
    let _filters = [...filters].filter(item=> item.value)
    const filter_params = _filters.reduce((acc, item) => {
      if(Array.isArray(item.value)){
        acc[item.key] = item.value.map(i=> i.value).join(",")
      }else{
        acc[item.key] = item.value;

      }
        return acc;
        }, {});
    return filter_params
  }


  export const timeSince = (date) => {
    if(date){
      return  formatDistanceToNow(new Date(date), { addSuffix: true })

    }
    return ""
  };


 export const isEventUpcoming = (eventDate) => {
    if (!eventDate) return null; 
  
    const today = startOfDay(new Date());
    const upcomingRange = addDays(today, 7);  
    
    const eventParsedDate = parse(eventDate, "MM/dd/yyyy", new Date());
    
    // For work anniversaries, check if the employee has been with the company for at least one year
    // Calculate years of service
    const yearsOfService = differenceInYears(today, eventParsedDate);
    
    // Only show anniversary if it's been at least one year
    if (yearsOfService < 1) {
      return null;
    }
    
    const eventThisYear = new Date(today.getFullYear(), eventParsedDate.getMonth(), eventParsedDate.getDate());
  
    if (isToday(eventThisYear)) {
      return "today"; 
    }
  
    if (isWithinInterval(eventThisYear, { start: today, end: upcomingRange })) {
      return "upcoming"; 
    }
  
    return null; 
  };


  export const renderEventStatus = (eventDate, emoji, text, badgeClass) => {
    const eventStatus = isEventUpcoming(eventDate);
  
    if (eventStatus === "today") {
      return (
        <>
          <span className="ms-2">{emoji}</span>
          {/* <span className={`badge ${badgeClass}`}>{"Celebrating Today !!"}</span> */}
        </>
      );
    }
  
    if (eventStatus === "upcoming") {
      return (
        <>
          <span className="ms-2">{emoji}</span>
          {/* <span className={`badge ${badgeClass}`}>{text}</span> */}
        </>
      );
    }
  
    return null;
  };
  